import type { CSSProperties, FC, ReactNode } from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

type CenteredSpinProps = {
  size?: SpinProps['size'];
  tip?: SpinProps['tip'];
  variant?: 'viewport' | 'fill';
  style?: CSSProperties;
  children?: ReactNode;
};

const viewportStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100vh',
};

const fillStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const CenteredSpin: FC<CenteredSpinProps> = ({
  size = 'large',
  tip,
  variant = 'viewport',
  style,
  children,
}) => {
  const wrapperStyle: CSSProperties = {
    ...(variant === 'fill' ? fillStyle : viewportStyle),
    ...style,
  };

  return (
    <div style={wrapperStyle}>
      <Spin size={size} />
      {tip ? <div style={{ marginTop: 8 }}>{tip}</div> : null}
      {children}
    </div>
  );
};

export default CenteredSpin;
